import React from 'react';
import { css, styled } from '@volkswagen-onehub/components-core';
import { SectionModel } from 'src/fetch-data/graphql';
import { ContentFeature } from './features/ContentFeature/ContentFeature';
import {
  renderAsHeading,
  renderMarkdown,
} from './features/ContentFeature/overrides/markdown';
import { Column, MediaColumn, Row } from './features/ContentFeature/styles';
import { MediaFeature } from './features/MediaFeature/MediaFeature';
import { isValidMedia } from './features/MediaFeature/helpers';
import { DisclaimerFeature } from './features/DisclaimerFeature/DisclaimerFeature';
import { IconListFeature } from './features/IconListFeature/IconListFeature';

const SectionLayout = styled.div<{ $isPrintMode?: boolean }>`
  ${({ $isPrintMode }) => ($isPrintMode ? css`` : css``)}
`;

interface SectionProps {
  section: SectionModel;
  isPrintMode?: boolean;
}

export const Section = ({ section, isPrintMode }: SectionProps) => {
  const { sectionTitle, sectionFooter } = section;
  const features = section.features ?? [];

  const renderTitle = sectionTitle && sectionTitle.html;
  const renderFooter = sectionFooter && sectionFooter.html;

  return (
    <SectionLayout $isPrintMode={isPrintMode} className='section-layout'>
      {renderTitle && (
        <Row>
          <Column>
            {renderAsHeading({
              text: sectionTitle.html!,
              level: 1,
              forceHeading: true,
              customStyle: {
                marginTop: 0,
              },
            })}
          </Column>
        </Row>
      )}

      {features.map((feat, idx) => {
        if (
          feat.__typename === 'QsgContentFeatureModel' ||
          feat.__typename === 'QsgContentfeatureModel'
        )
          return <ContentFeature key={`feature-${idx}`} feature={feat} />;

        if (
          (feat.__typename === 'QsgMediaFeatureModel' ||
            feat.__typename === 'QsgMediafeatureModel') &&
          isValidMedia(feat)
        )
          return (
            <MediaColumn key={`feature-${idx}`}>
              <MediaFeature feature={feat} />
            </MediaColumn>
          );

        if (
          feat.__typename === 'QsgDisclaimerFeatureModel' ||
          feat.__typename === 'QsgDisclaimerfeatureModel'
        )
          return <DisclaimerFeature key={`feature-${idx}`} feature={feat} />;

        if (
          feat.__typename === 'QsgIconlistFeatureModel' ||
          feat.__typename === 'QsgIconlistfeatureModel'
        )
          return <IconListFeature key={`feature-${idx}`} feature={feat} />;

        return null;
      })}

      {renderFooter && (
        <Row style={{ marginTop: '1rem' }}>
          <Column>{renderMarkdown({ text: sectionFooter.html! })}</Column>
        </Row>
      )}
    </SectionLayout>
  );
};
